import { render, staticRenderFns } from "./SendGridActivity.vue?vue&type=template&id=0925cbaa"
import script from "./SendGridActivity.vue?vue&type=script&lang=ts"
export * from "./SendGridActivity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports